import { usePageSeo } from "@/hooks/usePageSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const CookiePolicyPage = () => {
  usePageSeo("cookies");
  const { getSetting } = useSiteSettings();
  const company = getSetting("site_title", "World Transfers Punta Cana");
  const email = getSetting("email", "info@worldtransferspuntacana.com");

  return (
    <main className="min-h-screen bg-background">
      <section className="relative h-[40vh] flex items-end overflow-hidden bg-primary">
        <Navbar />
        <div className="container mx-auto px-4 relative z-10 pb-12 pt-24">
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-primary-foreground">Cookie Policy</h1>
          <p className="text-primary-foreground/60 mt-2 font-sans">Last updated: March 9, 2026</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-secondary" />
      </section>

      <section className="py-16 md:py-24 bg-background">
        <div className="container mx-auto px-4 max-w-3xl prose prose-neutral dark:prose-invert">
          <h2>1. What Are Cookies?</h2>
          <p>Cookies are small text files placed on your device when you visit a website. They help the site remember your preferences and improve your browsing experience.</p>

          <h2>2. How We Use Cookies</h2>
          <p>{company} uses cookies for the following purposes:</p>

          <h3>Essential Cookies</h3>
          <p>Required for the website to function properly. These include session cookies and authentication tokens. They cannot be disabled.</p>

          <h3>Analytics Cookies</h3>
          <p>Help us understand how visitors interact with our website by collecting anonymous usage data. This allows us to improve our services.</p>

          <h3>Functional Cookies</h3>
          <p>Remember your preferences (such as language or region) to provide a personalized experience.</p>

          <h3>Marketing Cookies</h3>
          <p>Used to deliver relevant advertisements and track the effectiveness of marketing campaigns. These may be set by third-party advertising partners.</p>

          <h2>3. Third-Party Cookies</h2>
          <p>Some cookies are placed by third-party services that appear on our pages, including:</p>
          <ul>
            <li>Google Analytics — for website traffic analysis</li>
            <li>Payment processors — for secure transaction handling</li>
            <li>Social media platforms — for sharing functionality</li>
          </ul>

          <h2>4. Managing Cookies</h2>
          <p>You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
          <ul>
            <li>View what cookies are stored and delete them individually</li>
            <li>Block third-party cookies</li>
            <li>Block cookies from specific sites</li>
            <li>Block all cookies</li>
            <li>Delete all cookies when you close your browser</li>
          </ul>
          <p>Please note that disabling cookies may affect the functionality of our website.</p>

          <h2>5. Changes to This Policy</h2>
          <p>We may update this Cookie Policy periodically. Any changes will be posted on this page.</p>

          <h2>6. Contact Us</h2>
          <p>If you have questions about our use of cookies, contact us at <a href={`mailto:${email}`} className="text-secondary hover:underline">{email}</a>.</p>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default CookiePolicyPage;
